/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ GlobalDrawer)
/* harmony export */ });
class GlobalDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeElements = this.querySelectorAll('[data-drawer-close]');
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.closeAllDrawers = this.closeAllDrawers.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-drawer'});
    window.eventBus.on('close:all:drawers', this.closeAllDrawers);
    this.closeElements.forEach((element) => {
      element.addEventListener('click', this.closeDrawer);
    });
    this.addEventListener('keydown', this.handleKeydown);
    if (this.getAttribute('aria-hidden') !== 'false') this.setAttribute('inert', '');

    if (window.Shopify.designMode) {
      window.addEventListener('resize', this.handleResize);
    }
  }

  openDrawer(returnFocusElement = document.activeElement) {
    window.eventBus.emit('close:all:drawers', this); // Close all other global drawers before opening this one
    if (this.getAttribute('aria-hidden') !== 'false') {
      this.returnFocusElement = returnFocusElement?.isConnected ? returnFocusElement : document.activeElement;
    }
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('js-drawer-open'); // Lock scroll
    this.addEventListener('transitionend', this.handleTransitionEnd);
    // Emit event when drawer opens
    window.eventBus.emit('drawer:opened', this);
    window.requestAnimationFrame(() => this.focusInitialControl());
  }

  closeDrawer() {
    const wasOpen = this.getAttribute('aria-hidden') === 'false';
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
    document.body.classList.remove('js-drawer-open'); // Unlock scroll
    this.removeEventListener('transitionend', this.handleTransitionEnd);
    // Emit event when drawer closes
    window.eventBus.emit('drawer:closed', this);
    if (wasOpen) this.restoreOpenerFocus();
  }

  restoreOpenerFocus() {
    if (this.returnFocusElement?.isConnected) this.returnFocusElement.focus();
  }

  closeAllDrawers(e) {
    if (e === this) return; // Only close other drawers not this one
    this.closeDrawer();
  }

  handleTransitionEnd(e) {
    if (e.target === this) {
      this.focusInitialControl();
    }
  }

  focusInitialControl() {
    if (this.getAttribute('aria-hidden') === 'false' && !this.contains(document.activeElement)) {
      this.getFocusableElements()[0]?.focus();
    }
  }

  handleKeydown(event) {
    if (this.getAttribute('aria-hidden') !== 'false' || this.querySelector('cart-update-modal[open]')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.closeDrawer();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusableElements = this.getFocusableElements();
    if (!focusableElements.length) return;
    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  getFocusableElements() {
    return [...this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.disabled && !element.hidden && !element.closest('[inert]') && element.getAttribute('aria-hidden') !== 'true');
  }

  handleResize() {
    this.classList.add('disable-transitions');
    setTimeout(() => {
      this.classList.remove('disable-transitions');
    }, 500);
  }

  disconnectedCallback() {
    window.eventBus.off('close:all:drawers', this.closeAllDrawers);
    this.closeElements.forEach((element) => element.removeEventListener('click', this.closeDrawer));
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('transitionend', this.handleTransitionEnd);
    if (window.Shopify.designMode) {
      window.removeEventListener('resize', this.handleResize);
    }
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/* harmony import */ var _global_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5669);


class CartDrawer extends _global_drawer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A {
  constructor() {
    super();
    this.dynamicContentIds = [
      'cart-header',
      'cart-body',
      'cart-footer'
    ];
    this.scrollElement = this.querySelector('[data-cart-scroll-element]');
    this.handleCartOpen = this.handleCartOpen.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.handleCartRender = this.handleCartRender.bind(this);
    this.status = this.querySelector('[data-cart-drawer-status]');
  }

  connectedCallback() {
    super.connectedCallback();
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-drawer'});
    window.eventBus.on('open:cart:drawer', this.handleCartOpen);
    window.eventBus.on('update:cart:drawer', this.handleCartUpdate);
    window.eventBus.on('render:cart:drawer', this.handleCartRender);
  }

  handleCartOpen(e) {
    /* ===== Scroll to top of the cart if necessary ===== */
    if (e?.scrollToTop && this.scrollElement) {
      this.scrollElement.scrollTo(0, 0);
    }

    /* ===== Open the drawer ===== */
    this.openDrawer(e?.returnFocusElement);
  }

  restoreOpenerFocus() {
    // Keep the original opener (including Add to cart) when usable. A header
    // trigger can remain connected but become hidden after a viewport change.
    const candidates = [this.returnFocusElement, ...document.querySelectorAll('[aria-controls="CartDrawer"]')];
    this.returnFocusElement = null;
    for (const element of candidates) {
      if (!element?.isConnected || element.disabled || element.closest('[inert], [hidden], [aria-hidden="true"]') || !element.getClientRects().length) continue;
      const style = window.getComputedStyle(element);
      if (style.visibility === 'hidden' || style.visibility === 'collapse') continue;
      element.focus({preventScroll: true});
      if (document.activeElement === element) return;
    }
  }

  handleCartUpdate(e) {
    if (!e) return;
    if (e.sections?.['cart-drawer']) {
      this.renderCartDrawer(e.sections['cart-drawer'], {
        focusKey: e.cartFocusKey,
        focusAction: e.cartFocusAction,
        announcement: e.cartAnnouncement,
      });
    }
  }

  renderCartDrawer(html, options = {}) {
    /* ===== Re-render cart drawer with updated content ===== */
    this.dynamicContentIds.forEach((id) => {
      const selector = `[data-cart-dynamic-content="${id}"]`;
      const updatedContent = this.getContent(html, selector);
      const targetElement = this.querySelector(selector);
      if (targetElement && updatedContent !== undefined) {
        targetElement.innerHTML = updatedContent;
      }
    });
    this.announce(options.announcement);
    window.requestAnimationFrame(() => this.restoreFocus(options));
  }

  restoreFocus({ focusKey, focusAction } = {}) {
    if (this.getAttribute('aria-hidden') !== 'false') return;
    if (focusAction === 'remove') {
      this.querySelector('[data-drawer-close]')?.focus();
      return;
    }
    if (!focusKey) return;
    [...this.querySelectorAll('[data-cart-focus-key]')]
      .find((element) => element.dataset.cartFocusKey === focusKey)
      ?.focus();
  }

  announce(message, isError = false) {
    if (!this.status || !message) return;
    this.status.textContent = '';
    this.status.setAttribute('role', isError ? 'alert' : 'status');
    window.requestAnimationFrame(() => {
      this.status.textContent = message;
    });
  }

  async handleCartRender() {
    /* ===== Fetch cart drawer using section rendering API (rather than bundled section rendering) - needed when adding more products to the cart than are in stock ===== */
    try {
      const response = await fetch(window.Shopify.routes.root + "?sections=cart-drawer");
      const responseJson = await response.json();
      if (responseJson?.['cart-drawer']) {
        this.renderCartDrawer(responseJson['cart-drawer']);
      }
    } catch (error) {
      this.announce('The cart could not be refreshed. Please open the cart page and try again.', true);
    }
  }

  getContent(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  disconnectedCallback() {
    window.eventBus.off('open:cart:drawer', this.handleCartOpen);
    window.eventBus.off('update:cart:drawer', this.handleCartUpdate);
    window.eventBus.off('render:cart:drawer', this.handleCartRender);
    super.disconnectedCallback();
  }
}

customElements.define('cart-drawer', CartDrawer);
/******/ })()
;
